import React from "react";
import Icon from "./Icon";

function ProfileGroupLink({ group }) {
  return (
    <a href={group.href} className="profile-card__group">
      <span className="profile-card__group-icon" aria-hidden="true">
        <Icon family="solid" name={group.icon} />
      </span>
      <span className="profile-card__group-name">{group.name}</span>
    </a>
  );
}

export default ProfileGroupLink;
